module.exports = __webpack_public_path__ + "static/img/003.13c8c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/003.png
// module id = UpvY
// module chunks = 1